import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Form } from "react-bootstrap";
import moment from "moment";
import { DatePicker } from "antd";
import _ from "lodash";
import { Creatable } from "react-select";
import SimpleReactValidator from "simple-react-validator";
import SearchSelect from "components/common/SearchSelect";
import UserTypes from "components/auth/user-types";
import {
    fetchSupervisors,
    fetchHelpers
} from "actions/employeeActions";

class TabWorkerMainInfo extends React.Component {
    constructor(props) {
        super(props);

        this.handleChangeHelper = this.handleChangeHelper.bind(this);

        this.state = {
            supervisorsOptions: this.props.supervisors.map(item => ({
                value: item.id,
                label: item.name
            })),
            helpersOptions: this.props.helpers.map(item => ({
                value: item.id,
                label: item.name
            })),
        };

        if (this.props.isEditable) {
            this.props.fetchSupervisors();
            this.props.fetchHelpers();
        }

        this.validator = new SimpleReactValidator({
            locale: "en",
            element: message => <div className="text-danger">{message}</div>
        });
    }

    componentWillReceiveProps (nextProps) {
        if (nextProps.isEditable) {
            const newStates = {};

            if (!_.isEqual(nextProps.supervisors, this.props.supervisors)) {
                newStates.supervisorsOptions = nextProps.supervisors.map(item => ({
                    value: item.id,
                    label: item.name
                }));
            }

            if (!_.isEqual(nextProps.helpers, this.props.helpers)) {
                newStates.helpersOptions = nextProps.helpers.map(item => ({
                    value: item.name,
                    label: item.name
                }));
            }

            if (nextProps.showValidation &&
                nextProps.showValidation !== this.props.showValidation) {
                this.validator.showMessages();
            }

            this.setState(newStates);
        }
    }

    componentWillUnmount() {
        if (this.props.isEditable) {
            this.props.fetchSupervisors(true);
        }
    }

    handleChangeHelper = (value) => {
        if (value && value.__isNew__) {
            const helpersOptions = Object.assign([], this.state.helpersOptions);
            helpersOptions.push(value);
            this.setState({
                helpersOptions
            });
        }

        this.props.onChange({
            target: {
                name: "helper",
                value: value ? value.value : null
            }
        }, this.props.tabKey);
    };

    render () {
        const { isEditable, auth } = this.props;
        const {
            supervisorsOptions,
            helpersOptions
        } = this.state;
        const role = auth?.user?.role || [];

        const supervisorId = this.props.getEmployeeValue("supervisorId", this.props.tabKey) || "";
        const currentSupervisor = supervisorId
            ? supervisorsOptions.find(item => item.value === supervisorId)
            : null;

        const helper = this.props.getEmployeeValue("helper", this.props.tabKey) || "";
        if (helpersOptions.findIndex(item => item.label === helper) === -1) {
            helpersOptions.push({
                label: helper,
                value: helper,
            });
        }
        const currentHelper = helper
            ? helpersOptions.find(item => item.label === helper)
            : null;

        return (
            <div className="container worker-main-info">
                <div className="row align-items-baseline form-inline">
                    <div className="col-5">
                        <Form.Group className="d-flex justify-content-end mb-2">
                            <label className="mr-3">Login Code</label>
                            <Form.Control
                                type="text"
                                readOnly={!isEditable || this.props.workerId}
                                name="code"
                                value={this.props.getEmployeeValue("code", this.props.tabKey)}
                                onChange={(ev) => this.props.onChange(ev, this.props.tabKey)}
                            />
                            {isEditable ?
                            <div className="valid-feedback d-block text-right text-primary">
                                Leave empty for auto-generated unique code
                            </div>
                            : null}
                        </Form.Group>
                        <Form.Group className="d-flex justify-content-end mb-2">
                            <label className="mr-3">First Name</label>
                            <Form.Control
                                type="text"
                                readOnly={!isEditable}
                                required={true}
                                name="firstName"
                                value={this.props.getEmployeeValue("firstName", this.props.tabKey)}
                                onChange={(ev) => this.props.onChange(ev, this.props.tabKey)}
                                onBlur={() => this.validator.showMessageFor("firstName")}
                            />
                            {this.validator.message("firstName", this.props.getEmployeeValue("firstName", this.props.tabKey), "required")}
                        </Form.Group>
                        <Form.Group className="d-flex justify-content-end mb-2">
                            <label className="mr-3">Last Name</label>
                            <Form.Control
                                type="text"
                                readOnly={!isEditable}
                                required={true}
                                name="lastName"
                                value={this.props.getEmployeeValue("lastName", this.props.tabKey)}
                                onChange={(ev) => this.props.onChange(ev, this.props.tabKey)}
                                onBlur={() => this.validator.showMessageFor("lastName")}
                            />
                            {this.validator.message("lastName", this.props.getEmployeeValue("lastName", this.props.tabKey), "required")}
                        </Form.Group>
                        <Form.Group className="d-flex justify-content-end mb-2">
                            <label className="mr-3">Date Started</label>
                            {isEditable ?
                            <DatePicker
                                value={this.props.getEmployeeValue("dateStarted", this.props.tabKey) !== ""
                                    && this.props.getEmployeeValue("dateStarted", this.props.tabKey) !== null
                                    ? moment(this.props.getEmployeeValue("dateStarted", this.props.tabKey))
                                    : null}
                                format="YYYY-MM-DD"
                                name="dateStarted"
                                onChange={(date) => {
                                    this.props.onChange({
                                        target: {
                                            name: "dateStarted",
                                            value: date ? moment(date).format("YYYY-MM-DD") : null,
                                            type: "date"
                                        }
                                    }, this.props.tabKey);
                                }}
                                className="d-block"
                                disabled={!isEditable}
                            />
                            :
                                <Form.Control
                                    type="text"
                                    readOnly={true}
                                    defaultValue={this.props.getEmployeeValue("dateStarted", this.props.tabKey) !== ""
                                        ? moment(this.props.getEmployeeValue("dateStarted", this.props.tabKey)).format("YYYY-MM-DD")
                                        : null}
                                />
                            }
                        </Form.Group>
                        {isEditable ?
                            <Form.Group className="d-flex justify-content-end mb-2">
                                <label className="mr-3">Payable To</label>
                                <Form.Control
                                    type="text"
                                    name="payableTo"
                                    value={this.props.getEmployeeValue("payableTo", this.props.tabKey)}
                                    onChange={(ev) => this.props.onChange(ev, this.props.tabKey)}
                                />
                            </Form.Group>
                        : null}
                        {isEditable ?
                        <Form.Group className="d-flex justify-content-end mb-2">
                            <label className="mr-3">Current Hourly Rate</label>
                            <Form.Control
                                type="number"
                                name="hourlyRate"
                                value={this.props.getEmployeeValue("hourlyRate", this.props.tabKey) || 0}
                                onChange={(ev) => this.props.onChange(ev, this.props.tabKey)}
                            />
                        </Form.Group>
                        : null}
                        {isEditable ?
                        <Form.Group className="d-flex justify-content-end mb-2">
                            <label className="mr-3">Current Salary</label>
                            <Form.Control
                                type="number"
                                name="currentSalary"
                                value={this.props.getEmployeeValue("currentSalary", this.props.tabKey) || 0}
                                onChange={(ev) => this.props.onChange(ev, this.props.tabKey)}
                            />
                        </Form.Group>
                        : null}
                    </div>

                    <div className="col-7 p-0">
                        <div className="container">
                            <div className="row mb-3">
                                <div className="col-3">
                                    <Form.Check
                                        type="checkbox"
                                        label="Merchandiser"
                                        checked={this.props.getEmployeeValue("isMerchandiser", this.props.tabKey)}
                                        className="justify-content-start"
                                        name="isMerchandiser"
                                        onChange={() => {
                                            if (isEditable) {
                                                this.props.onChange({
                                                    target: {
                                                        name: "isMerchandiser",
                                                        value: !this.props.getEmployeeValue("isMerchandiser", this.props.tabKey)
                                                    }
                                                }, this.props.tabKey);
                                            }
                                        }}
                                    />
                                    {this.validator.message("isMerchandiser",
                                        this.props.getEmployeeValue("isMerchandiser", this.props.tabKey, false)
                                        || this.props.getEmployeeValue("isSupervisor", this.props.tabKey, false)
                                        || this.props.getEmployeeValue("isAdministrator", this.props.tabKey, false)
                                        || this.props.getEmployeeValue("isAccountManager", this.props.tabKey, false) ? "true" : null, "required")}
                                </div>
                                <Form.Group className="col-6 justify-content-start">
                                    <label className="mr-3">Helper</label>
                                    {isEditable
                                        ? (
                                            <Creatable
                                                className="custom-react-select g-filter-select-no-padding w-75"
                                                isClearable
                                                onChange={this.handleChangeHelper}
                                                options={helpersOptions}
                                                value={currentHelper}
                                            />
                                        )
                                        : (
                                            <Form.Control
                                                type="text"
                                                readOnly={!isEditable}
                                                value={this.props.getEmployeeValue("helper", this.props.tabKey)}
                                                name="helper"
                                                onChange={(ev) =>
                                                    this.props.onChange(ev, this.props.tabKey)}
                                            />
                                        )
                                    }
                                </Form.Group>
                                <div className="col-3">
                                    <Form.Check
                                        type="checkbox"
                                        label="Inactive"
                                        checked={this.props.getEmployeeValue("inactive", this.props.tabKey)}
                                        className="justify-content-start"
                                        name="inactive"
                                        onChange={() => {
                                            if (isEditable) {
                                                this.props.onChange({
                                                    target: {
                                                        name: "inactive",
                                                        value: !this.props.getEmployeeValue("inactive", this.props.tabKey)
                                                    }
                                                }, this.props.tabKey);
                                            }
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-3">
                                    <Form.Check
                                        type="checkbox"
                                        label="Special Projects"
                                        checked={this.props.getEmployeeValue("isSpecialProjects", this.props.tabKey)}
                                        className="justify-content-start"
                                        name="isSpecialProjects"
                                        onChange={() => {
                                            if (isEditable) {
                                                this.props.onChange({
                                                    target: {
                                                        name: "isSpecialProjects",
                                                        value: !this.props.getEmployeeValue("isSpecialProjects", this.props.tabKey)
                                                    }
                                                }, this.props.tabKey);
                                            }
                                        }}
                                    />
                                </div>
                                <div className="col-3">
                                    <Form.Check
                                        type="checkbox"
                                        label="Supervisor"
                                        checked={this.props.getEmployeeValue("isSupervisor", this.props.tabKey)}
                                        className="justify-content-start"
                                        name="isSupervisor"
                                        onChange={() => {
                                            if (isEditable) {
                                                this.props.onChange({
                                                    target: {
                                                        name: "isSupervisor",
                                                        value: !this.props.getEmployeeValue("isSupervisor", this.props.tabKey)
                                                    }
                                                }, this.props.tabKey);
                                            }
                                        }}
                                    />
                                    {this.validator.message("isMerchandiser",
                                        this.props.getEmployeeValue("isMerchandiser", this.props.tabKey, false) ? "true" : null, "required")}
                                </div>
                                <div className="col-3">
                                    <Form.Check
                                        type="checkbox"
                                        label="Helper"
                                        checked={this.props.getEmployeeValue("isHelper", this.props.tabKey)}
                                        className="justify-content-start"
                                        name="isHelper"
                                        onChange={() => {
                                            if (isEditable) {
                                                this.props.onChange({
                                                    target: {
                                                        name: "isHelper",
                                                        value: !this.props.getEmployeeValue("isHelper", this.props.tabKey)
                                                    }
                                                }, this.props.tabKey);
                                            }
                                        }}
                                    />
                                    {this.validator.message("isMerchandiser",
                                        this.props.getEmployeeValue("isMerchandiser", this.props.tabKey, false) ? "true" : null, "required")}
                                </div>
                                <div className="col-3">
                                    <Form.Check
                                        type="checkbox"
                                        label="CRM Access"
                                        checked={this.props.getEmployeeValue("isCrmUser", this.props.tabKey)}
                                        className="justify-content-start"
                                        name="isCrmUser"
                                        onChange={() => {
                                            if (isEditable) {
                                                this.props.onChange({
                                                    target: {
                                                        name: "isCrmUser",
                                                        value: !this.props.getEmployeeValue("isCrmUser", this.props.tabKey)
                                                    }
                                                }, this.props.tabKey);
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-3">
                                    <Form.Check
                                        type="checkbox"
                                        label="Account Manager"
                                        checked={this.props.getEmployeeValue("isAccountManager",  this.props.tabKey)}
                                        className="justify-content-start"
                                        name="isAccountManager"
                                        onChange={() => {
                                            if (isEditable) {
                                                this.props.onChange({
                                                    target: {
                                                        name: "isAccountManager",
                                                        value: !this.props.getEmployeeValue("isAccountManager", this.props.tabKey)
                                                    }
                                                }, this.props.tabKey);
                                            }
                                        }}
                                    />
                                    {this.validator.message("isMerchandiser",
                                        this.props.getEmployeeValue("isMerchandiser", this.props.tabKey, false)
                                        || this.props.getEmployeeValue("isSupervisor", this.props.tabKey, false)
                                        || this.props.getEmployeeValue("isAdministrator", this.props.tabKey, false)
                                        || this.props.getEmployeeValue("isAccountManager", this.props.tabKey, false) ? "true" : null, "required")}
                                </div>
                                <div className="col-3">
                                    <Form.Check
                                        type="checkbox"
                                        label="Administrator"
                                        checked={this.props.getEmployeeValue("isAdministrator", this.props.tabKey)}
                                        className="justify-content-start"
                                        name="isAdministrator"
                                        onChange={() => {
                                            if (isEditable) {
                                                this.props.onChange({
                                                    target: {
                                                        name: "isAdministrator",
                                                        value: !this.props.getEmployeeValue("isAdministrator", this.props.tabKey)
                                                    }
                                                }, this.props.tabKey);
                                            }
                                        }}
                                    />
                                </div>
                                <div className="col-6">
                                    <Form.Check
                                        type="checkbox"
                                        label="Restricted HR options"
                                        checked={this.props.getEmployeeValue("isHrRestricted", this.props.tabKey)}
                                        className="justify-content-start"
                                        name="isHrRestricted"
                                        onChange={() => {
                                            if (isEditable) {
                                                this.props.onChange({
                                                    target: {
                                                        name: "isHrRestricted",
                                                        value: !this.props.getEmployeeValue("isHrRestricted", this.props.tabKey)
                                                    }
                                                }, this.props.tabKey);
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                            {(role.includes(UserTypes.admin) || role.includes(UserTypes.accountManager)) && (
                            <div className="row mb-3">
                                <div className="col-6">
                                    <Form.Check
                                        type="checkbox"
                                        label="Exclude from Auto Travel"
                                        checked={this.props.getEmployeeValue("excludeFromAutoTravel", this.props.tabKey)}
                                        className="justify-content-start"
                                        name="excludeFromAutoTravel"
                                        onChange={() => {
                                            if (isEditable) {
                                                this.props.onChange({
                                                    target: {
                                                        name: "excludeFromAutoTravel",
                                                        value: !this.props.getEmployeeValue("excludeFromAutoTravel", this.props.tabKey)
                                                    }
                                                }, this.props.tabKey);
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                            )}
                            <div className="row mb-3">
                                <Form.Group className="d-flex justify-content-end mb-2 w-100">
                                    <label className="mr-3">Supervisor</label>
                                        {isEditable ?
                                            <div className="w-50">
                                                <SearchSelect
                                                    className="custom-react-select g-filter-select-no-padding"
                                                    options={supervisorsOptions}
                                                    isClearable={false}
                                                    isMulti={false}
                                                    isLoading={false}
                                                    value={currentSupervisor}
                                                    onChange={item => {
                                                        this.props.onChange([{
                                                            name: "supervisorName",
                                                            value: item ? item.label : null
                                                        }, {
                                                            name: "supervisorId",
                                                            value: item ? item.value : null
                                                        }], this.props.tabKey);
                                                    }}
                                                />
                                                {this.validator.message("supervisorName",
                                                    this.props.getEmployeeValue("isMerchandiser", this.props.tabKey, false)
                                                        ? this.props.getEmployeeValue("supervisorId", this.props.tabKey, null)
                                                        : "true", "required")}
                                            </div>
                                            :
                                            <Form.Control
                                                type="text"
                                                readOnly={true}
                                                defaultValue={this.props.getEmployeeValue("supervisorName", this.props.tabKey)}
                                                className="w-50"
                                            />
                                        }
                                </Form.Group>
                                {isEditable ?
                                <Form.Group className="d-flex justify-content-end mb-2 w-100">
                                    <label className="mr-3">GST #</label>
                                    <Form.Control
                                        className="w-50"
                                        type="text"
                                        value={this.props.getEmployeeValue("gstNumber", this.props.tabKey) || 0}
                                        name="gstNumber"
                                        onChange={(ev) =>
                                            this.props.onChange(ev, this.props.tabKey)}
                                    />
                                </Form.Group>
                                : null}
                                <Form.Group className="d-flex justify-content-end mb-2 w-100">
                                    <label className="mr-3">Minimum Hours</label>
                                    <Form.Control
                                        className="w-50"
                                        type="number"
                                        readOnly={!isEditable}
                                        value={this.props.getEmployeeValue("minimumHours", this.props.tabKey) || 0}
                                        name="minimumHours"
                                        onChange={(ev) =>
                                            this.props.onChange(ev, this.props.tabKey)}
                                    />
                                </Form.Group>
                                <Form.Group className="d-flex justify-content-end mb-2 w-100">
                                    <label className="mr-3">Extras</label>
                                    <Form.Control
                                        className="w-50"
                                        type="text"
                                        readOnly={!isEditable}
                                        value={this.props.getEmployeeValue("extras", this.props.tabKey) || ""}
                                        name="extras"
                                        onChange={(ev) =>
                                            this.props.onChange(ev, this.props.tabKey)}
                                    />
                                </Form.Group>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

TabWorkerMainInfo.defaultProps = {
    isEditable: false,
    showValidation: false
};

TabWorkerMainInfo.propTypes = {
    workerId: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]).isRequired,
    tabKey: PropTypes.string.isRequired,
    getEmployeeValue: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    isEditable: PropTypes.bool,
    showValidation: PropTypes.bool,
    auth: PropTypes.object
};

const mapStateToProps = state => ({
    supervisors: state.employee.supervisors,
    accountManagers: state.employee.accountManagers,
    helpers: state.employee.helpers,
});

const mapStateToDispatch = dispatch => ({
    fetchSupervisors: bindActionCreators(fetchSupervisors, dispatch),
    fetchHelpers: bindActionCreators(fetchHelpers, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(TabWorkerMainInfo);
